module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8Dc8u"))).then(() => parcelRequire('d0iPb'));